export default __webpack_public_path__ + "static/media/5.b7e65d16.gif";